import { graphql, useStaticQuery } from 'gatsby';

export default () => {
  const { allStoryblokEntry } = useStaticQuery(graphql`
    query BlogPostQuery {
      allStoryblokEntry(filter: { lang: { eq: "default" }, field_component: { in: [ "Post", "download" ] } }) {
        nodes {
          uuid
          name
          full_slug
          content
          published_at(formatString: "MMMM d, YYYY")
        }
      }
    }
  `);

  const blogPosts = allStoryblokEntry.nodes.map((post) => {
    return {
      ...post,
      content: JSON.parse(post.content),
    };
  });

  return blogPosts;
};
